export const contentTableConfig = {
  title: '通话记录查询',
  propList: [
    {
      prop: 'corpName',
      label: '企业号',
      minWidth: '120'
    },
    { prop: 'serveId', label: '账户ID', minWidth: '80' },
    { prop: 'serveName', label: '名称', minWidth: '120' },
    { prop: 'usedBy', label: '使用人', minWidth: '80' },
    {
      prop: 'parentDeptName',
      label: '组',
      minWidth: '120'
    },
    {
      prop: 'deptName',
      label: '岗位',
      minWidth: '120'
    },
    {
      prop: 'customName',
      label: '客户名称',
      minWidth: '120',
      slotName: 'customName'
    },
    { prop: 'customId', label: '客户ID', minWidth: '80' },
    {
      prop: 'msgTime',
      label: '开始时间',
      minWidth: '120',
      slotName: 'beginTime',
      sortable: true
    },
    {
      prop: 'endTime',
      label: '结束时间',
      minWidth: '120',
      slotName: 'endTime',
      sortable: true
    },
    {
      prop: 'duration',
      label: '通话时长',
      minWidth: '120',
      slotName: 'duration',
      sortable: true,
      sortMethod: function (a: any, b: any) {
        return (
          parseFloat(a.duration) -
          parseFloat(b.duration)
        )
      }
    },
    { prop: 'actionName', label: '主叫/被叫', minWidth: '80' }
  ],
  showIndexColumn: false,
  showSelectColumn: false
}
